var exports = {
  "nN": "indicatorContainer__RjchFZ",
  "_r": "indicatorButton__TR2OB8",
  "lY": "indicatorText__sgBbC9",
};

module.exports = exports;
